import { formatDuration } from '@frameio/shared/transfers/utils';

const ONE_DAY = 24 * 60 * 60 * 1000;
const THREE_DAYS = 3 * ONE_DAY;
const THIRTY_DAYS = 30 * ONE_DAY;

/**
 * Computes the time remaining until an asset is scheduled to be deleted. The
 * minimum duration returned is `1d` so that we are accounting for potentially
 * exceeding the 30 day mark until the next deletion process runs.
 *
 * @param assetDeletedAt {string | null | undefined} The asset deletedAt date
 * @returns {[string, boolean]} A tuple consisting of the formatted duration string and a boolean indicating if the deletion is imminent
 */
export function getDurationUntilAssetHardDeletion(
  assetDeletedAt: string
): [string, boolean] {
  const deletedAtDate = new Date(assetDeletedAt);
  if (deletedAtDate.toString() === 'Invalid Date') {
    return ['', false];
  }

  const timeUntilDeletion = deletedAtDate.getTime() + THIRTY_DAYS - Date.now();
  if (timeUntilDeletion <= ONE_DAY) {
    return ['1d', true];
  }

  const isDeletionSoon = timeUntilDeletion <= THREE_DAYS;
  const formattedDuration = formatDuration(timeUntilDeletion / 1000);

  return [formattedDuration, isDeletionSoon];
}
